import { useId, type ReactNode } from 'react'
import { DisplayHeading } from '@carouselgg/nexus/display-heading'
import styles from './TrustSection.module.css'

/** A titled block of the trust page: condensed heading, a quiet aside, then the content. */
export function TrustSection({ title, aside, intro, children }: {
  title: string
  /** Sits beside the title: "7 games", "Up to 12 more points". */
  aside?: ReactNode
  /** A line under the title. */
  intro?: ReactNode
  children: ReactNode
}) {
  const id = useId()
  return (
    <section className={styles.section} aria-labelledby={id}>
      <div className={styles.head}>
        <DisplayHeading as="h2" size="3xl" id={id} className={styles.title}>{title}</DisplayHeading>
        {aside && <span className={styles.aside}>{aside}</span>}
      </div>
      {intro && <p className={styles.intro}>{intro}</p>}
      {children}
    </section>
  )
}
